import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { NumberOfEmployeesOptions } from 'enums/onboarding/crm';
import { FormSelectProps, SelectOption } from '@ui';

// components
import { FormSelect } from '@ui';

export type IProps = FormSelectProps;

const NumberOfEmployeesSelectIntakeForm = (props: IProps) => {
  const { t } = useTranslation('onboarding');

  const options = useMemo<SelectOption[]>(
    () =>
      Object.values(NumberOfEmployeesOptions).map((key) => ({
        id: key,
        label: t(`intake_form.number_of_employees_options.${key}`),
      })),
    [t],
  );

  return <FormSelect {...props} options={options} />;
};

export default NumberOfEmployeesSelectIntakeForm;
